import { SvgIcon as MuiSvgIcon, SvgIconProps } from '@mui/material';
import * as React from 'react';

import { withVersion } from '../../utils';
import { Icon, type IconProps } from '../base-icon';

const IconFacebookSvg = (props: SvgIconProps) => (
    <MuiSvgIcon {...props} viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073c0 6.016 4.388 11.005 10.125 11.927v-8.437H7.078v-3.49h3.047V9.413c0-3.023 1.791-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.973h-1.514c-1.491 0-1.956.93-1.956 1.885v2.263h3.328l-.532 3.49h-2.796V24C19.612 23.078 24 18.089 24 12.073Z"
        />
    </MuiSvgIcon>
);

export const IconFacebook = withVersion(
    React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
        <Icon
            ref={ref}
            iconComponent={IconFacebookSvg}
            outlineComponent={IconFacebookSvg}
            roundedComponent={IconFacebookSvg}
            {...props}
        />
    )),
    '1.0.0'
);
